import React from "react";
import { View, FlatList, StyleSheet, Dimensions, Platform } from "react-native";
import { COLORS } from "../../constants";
/**
 * DetailList Component
 *
 * This component is designed to render a list of details in a card format, incorporating icons and flexible text rendering.
 * It is highly customizable, allowing the parent component to dictate the rendering logic for names and details,
 * which makes it reusable in various parts of the application.
 *
 * Props:
 *  - data: Array of items to be rendered in the list.
 *  - FontAwesomeIcon: The FontAwesome icon component used for rendering icons.
 *  - iconSize: Size of the FontAwesome icon.
 *  - icon: FontAwesome icon name to be used in each list item.
 *  - renderItemName: Function to render the name part of each item.
 *  - renderItemDetails: Function to render additional details for each item.
 *
 * */
const { height } = Dimensions.get("window");
const DetailList = ({ data, FontAwesomeIcon, iconSize, icon, renderItemName, renderItemDetails, headerComponent }) => {
  const renderItem = ({ item }) => (
    <View style={styles.itemCard}>
      <View style={styles.iconContainer}>
        <FontAwesomeIcon icon={typeof icon === "function" ? icon(item) : icon} size={iconSize} color={COLORS.primary} />
      </View>
      <View style={styles.descriptionContainer}>
        {renderItemName && renderItemName(item.name)}
        {renderItemDetails && renderItemDetails(item)}
      </View>
    </View>
  );

  return (
    <FlatList
      data={data}
      ListHeaderComponent={headerComponent}
      renderItem={renderItem}
      keyExtractor={(item, index) => index.toString()}
      contentContainerStyle={styles.detailList}
    />
  );
};

const styles = StyleSheet.create({
  itemCard: {
    flexDirection: "row",
    marginBottom: 10,
    paddingTop: 16,
  },
  iconContainer: {
    marginRight: Platform.OS === "web" ? 20 : 16,
  },
  descriptionContainer: {
    flex: 1,
  },
  detailList: {
    paddingBottom: height * 0.15,
  },
});

export default DetailList;
